module.exports = __webpack_public_path__ + "static/assets/f81b6d748331012cd8e31bc1f24dcf48.svg";